import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPLocationDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ptp-location-edit",
    templateUrl: "./ptp-location-edit.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPLocationEditComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private route: ActivatedRoute,
        private router: Router,
        private message: NzMessageService,
        private fb: FormBuilder
    ) {}

    loading = true;
    isEditMode = false;
    locationId?: number;

    form: FormGroup = this.fb.group({
        shippingLocation: ["", [Validators.required, Validators.maxLength(200)]],
        shipToAddressLine1: [""],
        shipToAddressLine2: [""],
        shipToCity: [""],
        shipToState: [""],
        shipToZip: [""],
        shipToCountry: [""],
        shipToPhone: [""],
        shipToEmail: ["", [Validators.email]],
        shipToFax: [""]
    });

    async ngOnInit() {
        const id = this.route.snapshot.queryParamMap.get("id");
        if (!id) {
            this.loading = false;
            return;
        }

        this.isEditMode = true;
        this.locationId = Number(id);

        try {
            const loc = await lastValueFrom(this.api.getApiConfigurePtpLocationsId(this.locationId));
            this.form.patchValue({
                shippingLocation: loc.ShippingLocation,
                shipToAddressLine1: loc.ShipToAddressLine1,
                shipToAddressLine2: loc.ShipToAddressLine2,
                shipToCity: loc.ShipToCity,
                shipToState: loc.ShipToState,
                shipToZip: loc.ShipToZip,
                shipToCountry: loc.ShipToCountry,
                shipToPhone: loc.ShipToPhone,
                shipToEmail: loc.ShipToEmail,
                shipToFax: loc.ShipToFax
            });
        } catch (e) {
            this.message.error("Failed to load location");
            console.log(e);
        } finally {
            this.loading = false;
        }
    }

    save = async () => {
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(k => this.form.get(k)?.markAsTouched());
            return;
        }

        this.loading = true;

        const dto: PTPLocationDto = {
            PTPShippingLocationID: this.locationId,
            ShippingLocation: this.form.value.shippingLocation,
            ShipToAddressLine1: this.form.value.shipToAddressLine1,
            ShipToAddressLine2: this.form.value.shipToAddressLine2,
            ShipToCity: this.form.value.shipToCity,
            ShipToState: this.form.value.shipToState,
            ShipToZip: this.form.value.shipToZip,
            ShipToCountry: this.form.value.shipToCountry,
            ShipToPhone: this.form.value.shipToPhone,
            ShipToEmail: this.form.value.shipToEmail,
            ShipToFax: this.form.value.shipToFax
        };

        try {
            if (this.isEditMode) {
                await lastValueFrom(this.api.putApiConfigurePtpLocations(dto));
                this.message.success("Location updated");
            } else {
                await lastValueFrom(this.api.postApiConfigurePtpLocations(dto));
                this.message.success("Location created");
            }
            this.router.navigateByUrl("/configure/ptplocation");
        } catch (e) {
            this.message.error("Failed to save location");
            console.log(e);
            this.loading = false;
        }
    };
}
